import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { BaseService, Response } from '@tcc-mono/shared/data-access';
import { KvsRide, KvsRideAnimal } from '@tcc-mono/vandijk/shared/data-access/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { KvsReceiveRidesRetryResponse } from './dashboard.service';

export interface KvsDummyReceiveAnimal {
  id: number;
  country_code?: string | null;
  identification_number?: string | null;
  ride_id?: number | null;
  ride_number?: string | null;
  relation_name?: string | null;
  order_number?: string | null;
  kvs_animal_error_code?: string | null;
  kvs_animal_error_message?: string | null;
  kvs_dummy_ride_id?: number | null;
  kvs_dummy_error?: string | null;
}

export interface KvsDummyReceiveResult {
  succeeded: number;
  failed: number;
  kvs_dummy_ride_id: number | null;
  kvs_ride_number: number | null;
  animals: KvsDummyReceiveAnimal[];
}

@Injectable({
  providedIn: 'root'
})
export class KvsRideService extends BaseService<KvsRide> {
  constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = 'api/kvs'
  }

  public getAnimals = (rideId: string, hubId: number): Observable<KvsRideAnimal[]> => {
    return this._http.get<KvsRideAnimal[]>(`${this.getUrl(`${this.path}/rides/${rideId}/animals?hub_id=${hubId}`)}`);
  }

  public getIncomingRides = (hubId: number): Observable<KvsRide[]> => {
    return this._http.get<KvsRide[]>(`${this.getUrl(`${this.path}/incoming-rides?hub_id=${hubId}`)}`);
  }

  public retryReceiveRides(purchaseOrderId?: number): Observable<KvsReceiveRidesRetryResponse> {
    const body = purchaseOrderId ? { purchase_order_id: purchaseOrderId } : {};

    return this._http.post<KvsReceiveRidesRetryResponse>(
      this.getUrl(`${this.path}/receive-rides/retry`),
      body
    );
  }

  public getDummyReceiveAnimals(hubId: number, date: string): Observable<KvsDummyReceiveAnimal[]> {
    return this._http.get<Response<KvsDummyReceiveAnimal[]>>(
      this.getUrl(`${this.path}/dummy-receives`),
      { params: { hub_id: String(hubId), date } }
    ).pipe(map((response) => response.data ?? []));
  }

  public storeDummyReceive(hubId: number, date: string): Observable<KvsDummyReceiveResult> {
    return this._http.post<Response<KvsDummyReceiveResult>>(
      this.getUrl(`${this.path}/dummy-receives`),
      { hub_id: hubId, date }
    ).pipe(map((response) => response.data));
  }
}
